
import { Client } from "../types";
import { ContactButtons } from "@/components/common/ContactButtons";
import { Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ClientTeams } from "./ClientTeams";

interface ClientInfoProps {
  client: Client;
  onAssignTeams?: () => void;
}

export const ClientInfo = ({ client, onAssignTeams }: ClientInfoProps) => {
  return (
    <div className="space-y-2 w-full flex flex-col items-center">
      <div className="text-center">
        <h3 className="text-lg font-semibold">
          {client.first_name}
        </h3>
        <h3 className="text-lg font-semibold">
          {client.last_name}
        </h3>
      </div>
      
      <div className="flex flex-col items-center justify-center w-full gap-4 mt-4">
        {onAssignTeams && (
          <Button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onAssignTeams();
            }}
            className="bg-blue-500 hover:bg-blue-600 text-white flex items-center gap-2 w-full sm:w-auto"
          >
            <Users className="h-4 w-4" />
            <span>Assign Teams</span>
          </Button>
        )}
        
        <div className="flex items-center justify-center w-full gap-4">
          <ContactButtons 
            phoneNumber={client.mobile_phone} 
            email={client.email}
            name={`${client.first_name} ${client.last_name}`}
            size="lg"
          />
        </div>
        
        {/* Display assigned teams */}
        <div className="w-full mt-2">
          <ClientTeams clientId={client.id} />
        </div>
      </div>
    </div>
  );
};
